import React from 'react';
import {observer} from 'mobx-react';
import classNames from 'classnames';
import { OrbitComponentWithState } from '../../../../base-components/orbit-component-with-state/orbit-component-with-state';
import { AspectRatioContainerComponent } from '../../../../raw-components/aspect-ratio-container/aspect-ratio-container.component';
import {ArenaPictureBox} from './boxes/arena-picture/arena-picture.box';
import {ArenaTitleBox} from './boxes/arena-title/arena-title.box';
import {ArenaDescriptionTextBox} from './boxes/arena-description-text/arena-description-text.box';
import {LobbyGameInfoBox} from '../../boxes/lobby-game-info/lobby-game-info.box';
import {STICKY} from '../../../../../themes/css-global-classes';

export interface ArenaInfoPreviewComponentProps {
    isSticky?: boolean;
    arenaInfo: {
        previewImage: string;
        title: string;
        description: string;
    }
}

export interface ArenaInfoPreviewComponentState {
    arenaPictureLoading: boolean;
}

export const ArenaInfoPreviewComponent = observer(
    class ArenaInfoPreviewComponent extends OrbitComponentWithState<ArenaInfoPreviewComponentProps, ArenaInfoPreviewComponentState> {
        state: ArenaInfoPreviewComponentState = {
            arenaPictureLoading: false
        }

        render() {


            let title = this.services.translation.translate(this.props.arenaInfo.title);

            return (
                <LobbyGameInfoBox className={classNames('cy-arena-info-preview', {[STICKY]: this.props.isSticky})}>
                    <AspectRatioContainerComponent
                        width={372}
                        height={200}
                        isLoading={this.state.arenaPictureLoading}
                        useBGColorDuringLoadAnimation
                    >
                        <ArenaPictureBox
                            src={this.props.arenaInfo.previewImage}
                            alt={title}
                            width={372}
                            height={200}
                            lazy
                            onLoadStart={() => {
                                this.setState({arenaPictureLoading: true});
                            }}
                            onSettled={() => {
                                this.setState({arenaPictureLoading: false});
                            }}
                        />
                    </AspectRatioContainerComponent>
                    <ArenaTitleBox>
                        {title}
                    </ArenaTitleBox>
                    <ArenaDescriptionTextBox>
                        {this.services.translation.translate(this.props.arenaInfo.description)}
                    </ArenaDescriptionTextBox>
                </LobbyGameInfoBox>
            );
        }
    }
);

